import { render, staticRenderFns } from "./TheStakeholderRequestForm.vue?vue&type=template&id=c89a5c2a&scoped=true&"
import script from "./TheStakeholderRequestForm.vue?vue&type=script&lang=js&"
export * from "./TheStakeholderRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./TheStakeholderRequestForm.vue?vue&type=style&index=0&id=c89a5c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a5c2a",
  null
  
)

export default component.exports